import { lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "@/i18n/I18nProvider";
import { ThemeProvider } from "@/context/Theme";
import { AuthProvider } from "@/context/AuthContext";
import { FavoritesProvider } from "@/context/Favorites";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/layout/Layout";
import { RequireAuth, RequireStaff } from "@/components/layout/Guards";
import { Spinner } from "@/components/common/States";
import Home from "@/pages/Home";
import SignIn from "@/pages/SignIn";

const Search = lazy(() => import("@/pages/Search"));
const PropertyDetails = lazy(() => import("@/pages/PropertyDetails"));
const AddProperty = lazy(() => import("@/pages/AddProperty"));
const Onboarding = lazy(() => import("@/pages/Onboarding"));
const Dashboard = lazy(() => import("@/pages/Dashboard"));
const Admin = lazy(() => import("@/pages/Admin"));
const Offices = lazy(() => import("@/pages/Offices"));
const AgencyProfile = lazy(() => import("@/pages/AgencyProfile"));
const Wanted = lazy(() => import("@/pages/Wanted"));
const StaticPage = lazy(() => import("@/pages/StaticPage"));
const NotFound = lazy(() => import("@/pages/NotFound"));

function App() {
  return (
    <ThemeProvider>
    <I18nProvider>
      <BrowserRouter>
          <AuthProvider>
            <FavoritesProvider>
              <Suspense fallback={<Spinner />}>
                <Routes>
                  <Route path="/sign-in/*" element={<SignIn />} />
                  <Route path="/sign-up/*" element={<SignIn />} />
                  <Route element={<Layout />}>
                    <Route index element={<Home />} />
                    <Route path="search" element={<Search />} />
                    <Route path="property/:key" element={<PropertyDetails />} />
                    <Route path="offices" element={<Offices />} />
                    <Route path="office/:slug" element={<AgencyProfile />} />
                    <Route path="wanted" element={<Wanted />} />
                    <Route path="page/:slug" element={<StaticPage />} />
                    <Route path="onboarding" element={<RequireAuth><Onboarding /></RequireAuth>} />
                    <Route path="add-property" element={<RequireAuth><AddProperty /></RequireAuth>} />
                    <Route path="dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
                    <Route path="admin" element={<RequireAuth><RequireStaff><Admin /></RequireStaff></RequireAuth>} />
                    <Route path="*" element={<NotFound />} />
                  </Route>
                </Routes>
              </Suspense>
              <Toaster position="top-center" richColors />
            </FavoritesProvider>
          </AuthProvider>
      </BrowserRouter>
    </I18nProvider>
    </ThemeProvider>
  );
}

export default App;
